import React from "react";
import { Card, Button } from "react-bootstrap";

export default function VideoCard({ video }) {
  return (
    <Card className="h-100 shadow-sm" style={{ borderRadius: 12 }}>
      <Card.Img
        variant="top"
        src={video.thumbnail}
        alt={video.title}
        style={{
          height: 180,
          objectFit: "cover",
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12,
        }}
        loading="lazy"
      />

      <Card.Body className="d-flex flex-column">
        <Card.Title style={{ fontSize: "1.05rem" }}>{video.title}</Card.Title>

        {video.blurb ? (
          <Card.Text className="text-muted" style={{ fontSize: ".95rem" }}>
            {video.blurb}
          </Card.Text>
        ) : null}

        <div className="mt-auto d-flex gap-2">
          <Button
            as="a"
            href={video.href}
            target="_blank"
            rel="noreferrer"
            variant="outline-primary"
          >
            Watch on YouTube →
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
}
